import { render, staticRenderFns } from "./EdocEdit.vue?vue&type=template&id=1db67efe"
import script from "./EdocEdit.vue?vue&type=script&lang=js"
export * from "./EdocEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports